import {
    // Types
    CREATE_PROPOSED_CHANGE,
    CREATE_PROPOSED_LINK,
    CREATE_PROPOSED_REGULATION,
    CREATED_REGULATION_RECEIVED,
    GET_DIVIDED_LINK,
    IS_TOAST_POPUP_ENABLED_FOUR,
    IS_TOAST_POPUP_ENABLED_THREE,
    IS_TOAST_POPUP_ENABLED_TWO,
    IS_TOAST_POPUP_ENABLED,
    POST_PROPOSED_REGULATION_LINKS,
    PROPOSED_LINK_CREATED,
    RECEIVED_DIVIDED_LINK,
    SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED,
    SET_HOVERED_SEGMENT_TO_BE_CREATED,
    SET_SEGMENTS_TO_BE_CREATED,
    STORE_ADJACENT_LINKS,
    STORE_PROPOSED_ADJACENT_LINKS,
    STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS,
    STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS,
    TOGGLE_CREATE_OPTIONS_PANEL,
    TOGGLE_CREATE_REGULATION_PANEL,
    TOGGLE_DRAW_CUSTOM_GROUP,
    ToggleCreateRegulationPanelAction,
    ToggleCreateOptionsPanel,
    ToggleDrawCustomGroupAction,
    ToggleToastPopupEnabledAction,
    ToggleToastPopupEnabledTwoAction,
    ToggleToastPopupEnabledThreeAction,
    ToggleToastPopupEnabledFourAction,
    SetSegmentsToBeCreatedAction,
    SetHoveredSegmentToBeCreateAction,
    SetCustomGroupSegmentsToBeHighlightedAction,
    CreateProposedRegulationAction,
    CreatedRegulationReceivedAction,
    CreateProposedRegulationLinksAction,
    StoreToBeCreatedCustomGroupSegmentsAction,
    StoreToBeConfirmedCustomGroupSegmentsAction,
    CreateProposedLinkAction,
    ProposedLinkCreatedAction,
    GetDividedLinkAction,
    ReceivedDividedLinkAction,
    createProposedChangeAction,
    storeAdjacentLinksAction,
    storeProposedAdjacentLinksAction,
    TOGGLE_SCENARIO_PANEL,
    ToggleProjectPanel,
    TOGGLE_PROJECT_PANEL
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const toggleCreateRegulationPanel = createAction<
    ToggleCreateRegulationPanelAction["payload"]
>(TOGGLE_CREATE_REGULATION_PANEL);

export const toggleProjectPanel = createAction<ToggleProjectPanel["payload"]>(TOGGLE_PROJECT_PANEL);

export const toggleCreateOptionsPanel = createAction<ToggleCreateOptionsPanel["payload"]>(
    TOGGLE_CREATE_OPTIONS_PANEL
);

export const toggleDrawCustomGroup =
    createAction<ToggleDrawCustomGroupAction["payload"]>(TOGGLE_DRAW_CUSTOM_GROUP);

export const togglePopupEnabled =
    createAction<ToggleToastPopupEnabledAction["payload"]>(IS_TOAST_POPUP_ENABLED);

export const togglePopupEnabledTwo = createAction<ToggleToastPopupEnabledTwoAction["payload"]>(
    IS_TOAST_POPUP_ENABLED_TWO
);

export const togglePopupEnabledThree = createAction<ToggleToastPopupEnabledThreeAction["payload"]>(
    IS_TOAST_POPUP_ENABLED_THREE
);

export const togglePopupEnabledFour = createAction<ToggleToastPopupEnabledFourAction["payload"]>(
    IS_TOAST_POPUP_ENABLED_FOUR
);

export const setSegmentsToBeCreated = createAction<SetSegmentsToBeCreatedAction["payload"]>(
    SET_SEGMENTS_TO_BE_CREATED
);

export const setHoveredSegmentToBeCreated = createAction<
    SetHoveredSegmentToBeCreateAction["payload"]
>(SET_HOVERED_SEGMENT_TO_BE_CREATED);

export const setCustomGroupSegmentsToBeHighlighted = createAction<
    SetCustomGroupSegmentsToBeHighlightedAction["payload"]
>(SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED);

export const createProposedRegulation = createAction<CreateProposedRegulationAction["payload"]>(
    CREATE_PROPOSED_REGULATION
);

export const createdProposedRegulationReceived = createAction<
    CreatedRegulationReceivedAction["payload"]
>(CREATED_REGULATION_RECEIVED);

export const createProposedRegulationLinks = createAction<
    CreateProposedRegulationLinksAction["payload"]
>(POST_PROPOSED_REGULATION_LINKS);

export const storeToBeCreatedCustomGroupSegments = createAction<
    StoreToBeCreatedCustomGroupSegmentsAction["payload"]
>(STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS);

export const storeToBeConfirmedCustomGroupSegments = createAction<
    StoreToBeConfirmedCustomGroupSegmentsAction["payload"]
>(STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS);

export const createProposedLink =
    createAction<CreateProposedLinkAction["payload"]>(CREATE_PROPOSED_LINK);

export const proposedLinkCreated =
    createAction<ProposedLinkCreatedAction["payload"]>(PROPOSED_LINK_CREATED);

export const getDividedLink = createAction<GetDividedLinkAction["payload"]>(GET_DIVIDED_LINK);

export const receivedDividedLink =
    createAction<ReceivedDividedLinkAction["payload"]>(RECEIVED_DIVIDED_LINK);

export const createProposedChange =
    createAction<createProposedChangeAction["payload"]>(CREATE_PROPOSED_CHANGE);

export const storeAdjacentLinks =
    createAction<storeAdjacentLinksAction["payload"]>(STORE_ADJACENT_LINKS);

export const storeProposedAdjacentLinks = createAction<storeProposedAdjacentLinksAction["payload"]>(
    STORE_PROPOSED_ADJACENT_LINKS
);
